var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 63,
    viewBox: "0 0 97 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5707 0H62.4293L97 63H7L41.5707 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0334 19.0308C63.1332 18.0351 61.51 17.7847 57.5434 17.7847L43.979 17.7877L28.0007 0.721431C27.6259 0.324953 27.0327 -0.0029637 26.6785 2.02047e-05L21.8265 0.0179079C21.4723 0.0208888 21.4517 0.465064 21.7793 1.00763L31.9021 17.7877H13.6035L5.46096 6.70147C5.20714 6.35865 4.71131 6.07843 4.36012 6.07843H0.673887C0.319725 6.07843 0.145594 6.44808 0.284312 6.8982L3.63116 17.7883H1.47075C-0.32957 17.7883 -0.509616 20.7783 1.11068 22.0244C2.73685 23.2675 16.9802 29 18.9605 29H57.3604C62.7732 29 68 26.5079 68 23.5179C68 22.0244 64.9335 20.0294 64.0334 19.0308Z",
    fill: "url(#paint0_linear_4_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_10",
    x1: -0.867709,
    y1: 12.3921,
    x2: 84.5888,
    y2: 31.3966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309653,
    stopColor: "#EA50E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#FAFF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.1d30c43ccdcbceca47e06488442df8e0.svg";
export { ForwardRef as ReactComponent };